import { apiClient } from "./client";
import { csrf } from "./csrf";

export type Me = {
  id: string;
  tenant_id: string;
  email: string;
  role: string;
  email_verified_at: string | null;
  created_at: string;
};

export async function fetchMe(): Promise<Me | null> {
  const { data, error, response } = await apiClient.GET("/auth/me");
  if (response.status === 401) return null;
  if (error) throw new Error(JSON.stringify(error));
  return (data as Me) ?? null;
}

export async function login(input: {
  tenant_slug: string;
  email: string;
  password: string;
}): Promise<Me> {
  const { data, error } = await apiClient.POST("/auth/login", { body: input });
  if (error) throw new Error(JSON.stringify(error));
  csrf.set((data as any).csrf_token);
  return (data as any).user as Me;
}

export async function register(input: {
  tenant_slug: string;
  tenant_name: string;
  email: string;
  password: string;
}): Promise<Me> {
  const { data, error } = await apiClient.POST("/auth/register", {
    body: input,
  });
  if (error) throw new Error(JSON.stringify(error));
  return data as Me;
}

export async function logout(): Promise<void> {
  await apiClient.POST("/auth/logout", {});
  csrf.clear();
}

export async function forgotPassword(input: {
  tenant_slug: string;
  email: string;
}): Promise<void> {
  const { error } = await apiClient.POST("/auth/forgot-password", {
    body: input,
  });
  if (error) throw new Error(JSON.stringify(error));
}

export async function resetPassword(input: {
  token: string;
  new_password: string;
}): Promise<void> {
  const { error } = await apiClient.POST("/auth/reset-password", {
    body: input,
  });
  if (error) throw new Error(JSON.stringify(error));
}

export async function requestMagicLink(input: {
  tenant_slug: string;
  email: string;
}): Promise<void> {
  const { error } = await apiClient.POST("/auth/magic-link", { body: input });
  if (error) throw new Error(JSON.stringify(error));
}

export async function consumeMagicLink(token: string): Promise<Me> {
  const { data, error } = await apiClient.POST("/auth/magic-link/consume", {
    body: { token },
  });
  if (error) throw new Error(JSON.stringify(error));
  csrf.set((data as any).csrf_token);
  return (data as any).user as Me;
}
